import {Badge} from 'react-bootstrap'

const COLORS = {
  COMPLETED: 'success',
  DRAFT: 'warning',
}

export const BadgeStatus = ({state}: {state: string}) => {
  return <Badge bg={COLORS[state]}>{state}</Badge>
}
